export default __webpack_public_path__ + "static/media/Our-Network.291c3468.png";